import { t } from '@lingui/core/macro'
import { CreateUser } from './CreateUser'
import { SignupContainer } from './SignupContainer'
import { useActivationCodeTerminology } from './signupForm'

export function VoucherSignup({
  voucherCode,
  customerGroupOverride,
}: {
  voucherCode?: string
  customerGroupOverride?: string
}) {
  return (
    <SignupContainer title={t`Create new account`}>
      <CreateUser
        allowAppPromotion
        type="voucher"
        customerGroupOverride={customerGroupOverride}
        prefill={{
          voucherCode,
        }}
      />
    </SignupContainer>
  )
}
